import React, { useEffect } from "react";
import { v4 as uuid } from "uuid";
import styles from "../floorplanTool.module.css";
import {
  useActions,
  useAppState,
  useControlTarget,
  useDisplaySettings,
  useExterior,
  usePointerCoordinates,
} from "../hooks";
import { snap, toFeetInchesString } from "../utils";
import { ControlPoint } from "./";

const controlPoint1Id = uuid();
const controlPoint2Id = uuid();

function SidePorch() {
  const [exterior, exteriorDispatch] = useExterior();
  const [appState, appStateDispatch] = useAppState();
  const [controlTarget] = useControlTarget();
  const [displaySettings] = useDisplaySettings();
  const [coordinates] = usePointerCoordinates();
  const actions = useActions({ exteriorDispatch, appStateDispatch });

  useEffect(() => {
    if (appState.isDraggingPorchHandle) {
      if (
        controlTarget === controlPoint1Id ||
        controlTarget === controlPoint2Id
      ) {
        actions.setPorchMax(snap(exterior.height - 12, 6));
        actions.setPorchMin(snap(exterior.height - coordinates.y, 6));
      }
    }
  }, [controlTarget, coordinates]);

  return (
    <g>
      <rect
        x={0}
        y={0}
        width={exterior.width}
        height={exterior.height - exterior.porchMin}
        fill="none"
        stroke={appState.editingPorch ? "#0d6efd" : "black"}
        strokeWidth={2}
      />
      <text
        x={6}
        y={exterior.height - displaySettings.fontSize}
        fontSize={displaySettings.fontSize}
        className={styles.svgTxt}
      >
        Side Porch ({toFeetInchesString(exterior.porchMin)} Depth)
      </text>
      {appState.editingPorch ? (
        <>
          <ControlPoint
            id={controlPoint1Id}
            className="sidePorchControlPoint"
            cx={0}
            cy={exterior.height - exterior.porchMin}
            onMouseDown={() => actions.setIsDraggingPorchHandle(true)}
            onTouchStart={() => actions.setIsDraggingPorchHandle(true)}
          />
          <ControlPoint
            id={controlPoint2Id}
            className="sidePorchControlPoint"
            cx={exterior.width}
            cy={exterior.height - exterior.porchMin}
            onMouseDown={() => actions.setIsDraggingPorchHandle(true)}
            onTouchStart={() => actions.setIsDraggingPorchHandle(true)}
          />
        </>
      ) : null}
    </g>
  );
}

export default SidePorch;
